<template>
  <va-create-layout>
    <user-form :title="title" :item="item"></user-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
